var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-snackbar-component"},[_c('v-snackbar',{attrs:{"color":_vm.color,"content-class":"text-center"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }